import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box, Typography } from '@mui/material';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, token } = useAuth();

  if (process.env.NODE_ENV === 'development') {
    console.log('ProtectedRoute - isAuthenticated:', isAuthenticated, 'isLoading:', isLoading, 'token:', token ? 'EXISTS' : 'NULL');
  }

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh" flexDirection="column">
        <CircularProgress />
        <Typography variant="body2" sx={{ mt: 2 }}>Verifying authentication...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    if (process.env.NODE_ENV === 'development') {
      console.log('Not authenticated, redirecting to login');
    }
    return <Navigate to="/login" replace />;
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('Authenticated, rendering protected content');
  }
  return <>{children}</>;
};

export default ProtectedRoute;
